import axios from 'axios';
import ConfigConnection from '../config/config.service';
export default class DetailService{
  // API Instance
  configConnection: any = new ConfigConnection();

  getById(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/${user_id}`, config);
  }

  getByCompany(company_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company/${company_id}`, config);
  }

  getBySupport(supportId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}support/${supportId}`, config);
  }

  getByCandidates(user_id){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}user/${user_id}`, config);
  }

  getByBusiness(idBusiness){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}business/${idBusiness}`, config);
  }

  getByRoles(idRole){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}role/${idRole}`, config);
  }

  getBySurvey(idSurvey){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}survey/${idSurvey}`, config);
  }

  getByJob(idJob){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}job/${idJob}`, config);
  }

  getBySection(idSection){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}section/${idSection}`, config);
  }

  getByResources(resourceId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}resource/${resourceId}`, config);
  }

  getBySkill(idSkill){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}skill/${idSkill}`, config);
  }

  getByQuestion(idQuestion){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}question/${idQuestion}`, config);
  }

  getByProfile(profileId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}profile/${profileId}`, config);
  }

  getSurveyResults(userSurveyId){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    console.log(`${_.configConnection.apiInstance}user/candidate/${userSurveyId}/report`, ' Yet')
    return axios.post(`${_.configConnection.apiInstance}user/candidate/${userSurveyId}/report`, '' ,config);
  }

  getCompanies(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}company`, config);
  }

  getProfile(){
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };
    return axios.get(`${_.configConnection.apiInstance}profile`, config);
  }

  public resendAccountEmail(candidateId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('tk_auth')}`
      }
    };

    return axios.post(`${_.configConnection.apiInstance}candidate/${candidateId}/resend-account-email`, '', config);
  }
}
